import { makeStyles } from '@material-ui/core'

export default makeStyles(() => ({
  button: {
    // && dobra a especificidade para vencer o `.leaflet-bar a { display: block }`;
    // margem no ícone não serve: ela vaza para fora do <a> e o botão cresce
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  mapContainer: {
    height: '100%',
    width: '100%',
    minHeight: 300,
  },
}))
